'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var warningMessages = {
  date: 'The input has to be a valid date format!',
  datetime: 'The input has to be a valid datetime format!',
  email: 'The input has to be an email!',
  exactly: 'The input has to be exactly like __VAR1__!',
  "float": 'The input has to be a float!',
  integer: 'The input has to be an integer!',
  maxChar: 'The input has to be max. __VAR1__ letters!',
  minChar: 'The input has to be min. __VAR1__ letters!',
  minMaxChar: 'The input has to be min. __VAR1__ and max. __VAR2__ letters!',
  not: 'The input is not allowed to be: __VAR1__!',
  number: 'The input has to be a number!',
  phonenumber: 'The input has to be a phonenumber!',
  requiredField: 'This field is required!',
  time: 'The input has to be a valid time format!',
  url: 'The input has to be a valid url!',
  validation: 'The input is not valid!'
};
exports["default"] = warningMessages;
module.exports = exports['default'];